import React from 'react'

import NewServiceCategory from './NewServiceCategory'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'


const NewServiceCategoryPage = () => (
  <section>
    <header>
      <PageTitle>New Service category</PageTitle>
    </header>
    <NewServiceCategory showSuccessDialog={true} />
    <br/>
    <BackButton/>
  </section>
)

export default NewServiceCategoryPage



// WEBPACK FOOTER //
// ./src/components/ServiceCategories/NewServiceCategoryPage.jsx